import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class InvoiceEstimatesService extends AbstractService {
	static setup(baseURL, options) {
		instance = new InvoiceEstimatesService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = APIEndpoints.jobEstimates;
		this.jobEventInvoiceEstimate = APIEndpoints.jobEstimates;
	}

	static getAll(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getCounts(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getCounts(...params);
	}

	static getInvoiceEstimateFromId(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getInvoiceEstimateFromId(...params);
	}

	static getInvoiceEstimateFromToken(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getInvoiceEstimateFromToken(...params);
	}

	static getInvoiceEstimatePDFFromId(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getInvoiceEstimatePDFFromId(...params);
	}

	static getInvoiceEstimatePDFFromToken(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getInvoiceEstimatePDFFromToken(...params);
	}

	static approveEstimateFromId(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._approveEstimateFromId(...params);
	}

	static approveEstimateFromToken(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._approveEstimateFromToken(...params);
	}

	static getEstimateByData(...params) {
		if (instance === null) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getEstimateByData(...params);
	}

	_getAll({ getCancelToken, ...rest }) {
		return this.get({
			endpoint    : this.endpoint,
			queryParams : rest,
			getCancelToken,
		});
	}

	_getCounts(queryParams) {
		return this.get({
			endpoint : `${this.endpoint}/${APIEndpoints.counts}`,
			queryParams,
		});
	}

	_getInvoiceEstimateFromId(id) {
		return this.get({
			endpoint    : this.jobEventInvoiceEstimate,
			queryParams : { invoiceEstimateId : id },
		});
	}

	_getInvoiceEstimateFromToken(token) {
		return this.get({
			endpoint : `${this.jobEventInvoiceEstimate}/tokenized/${token}`,
		});
	}

	_getInvoiceEstimatePDFFromId(id) {
		return this.get({
			endpoint     : `${this.jobEventInvoiceEstimate}/pdf`,
			queryParams  : { invoiceEstimateId : id },
			responseType : 'blob',
		});
	}

	_getInvoiceEstimatePDFFromToken(token) {
		return this.get({
			endpoint     : `${this.jobEventInvoiceEstimate}/tokenized/${token}/pdf`,
			responseType : 'blob',
		});
	}

	_approveEstimateFromId(id, queryParams, data) {
		return this.post({
			endpoint    : `${this.jobEventInvoiceEstimate}/approve`,
			queryParams : { ...queryParams, invoiceEstimateId : id },
			data,
		});
	}

	_approveEstimateFromToken(token, queryParams, data) {
		return this.post({
			endpoint : `${this.jobEventInvoiceEstimate}/tokenized/${token}/approve`,
			queryParams,
			data,
		});
	}

	_getEstimateByData({ queryParams, data }) {
		return this.post({
			endpoint : `${APIEndpoints.clientjobrequest}/invoiceestimate`,
			queryParams,
			data,
		});
	}
}
